import React from 'react';

import {EmoticonOutlineIcon} from '@time-webkit/all/icons/emoticon-outline';

export default class EmojiIcon extends React.PureComponent<React.HTMLAttributes<HTMLSpanElement>> {
    render() {
        return (
            <span {...this.props}>
                <EmoticonOutlineIcon width={16} height={16} />
            </span>
        );
    }
}
